import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useMemo } from "react";
import { useCountCombinedEventsByStatusQuery } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../auth/useLoggedInWithOrgContextState";
import { useSub } from "../../subscription/useSub";
import type { NavBadgeKey } from "./navConfig";
import { countBadgesByStatus } from "./statusBuckets";

export type NavBadges = Partial<Record<NavBadgeKey, number>>;

/**
 * Real count badges for the sidebar's procurement-status items, grouped by the exhaustive bucket
 * maps. The BFF counts per status in one query over the report view, covering both older (V1) and
 * new (V2) events — the same population the badge's own link opens. The needs (behov*) buckets have
 * no backend yet and stay absent. Only queries for buyer organisations whose user can view sourcing
 * events — the counts cover private procurements too, so they must not hang off the
 * public-procurement flag, and they decorate items a contract-only role never sees.
 */
export const useNavBadges = (): NavBadges => {
  const sub = useSub();
  const authState = useLoggedInWithOrgContextState();
  const { data } = useCountCombinedEventsByStatusQuery(
    sub.hasBuyerAccess && sub.canViewSourcingEvents ? { orgId: authState.selectedOrg.id } : skipToken
  );

  return useMemo(() => countBadgesByStatus(data?.counts ?? []), [data]);
};
